export default "__VITE_ASSET__BXCfdHij__"